import { ReactNode } from 'react';

export type ChooseApplianceCareArticleProps = {
  icon: ReactNode;
  description: string;
  key?: number;
};

export const ChooseApplianceCareArticle = ({
  icon,
  description,
}: ChooseApplianceCareArticleProps) => (
  <article className="flex flex-col items-center text-center">
    <figure className="mb-space-400 text-primary-600">{icon}</figure>
    <p>{description}</p>
  </article>
);
